import _regeneratorRuntime from "/data/repos/372_20260903142405/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/data/repos/372_20260903142405/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import { hexToRGB } from 'cfmoto-utils';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#0B2C82'
    },
    opacity: {
      type: Number,
      default: 1
    },
    onBack: {
      type: Function
    },
    border: {
      type: Boolean,
      default: true
    },
    visibleHeight: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      default: 'default' // default/transprent
    },
    leftIconColor: {
      type: String,
      default: '' // default/transprent
    }
  },
  components: {},
  data: function data() {
    return {
      scrollY: 0,
      scrollHeight: 150
    };
  },
  computed: {
    statusBarRootStyles: function statusBarRootStyles() {
      if (!this.isApp || !this.visibleHeight) {
        return {
          minHeight: 0,
          maxHeight: 0
        };
      }
      var minHeight = "calc(".concat(window.cfmoto.statusBarHeight(), " + 44px)");
      return {
        minHeight: minHeight
      };
    },
    statusBarWrapStyles: function statusBarWrapStyles() {
      var paddingTop = "".concat(window.cfmoto.statusBarHeight());
      var minHeight = "calc(".concat(window.cfmoto.statusBarHeight(), " + 44px)");
      return {
        minHeight: minHeight,
        paddingTop: paddingTop
      };
    },
    alpha: function alpha() {
      var mode = this.mode,
        scrollY = this.scrollY;
      if (mode === 'default') {
        return 1;
      }
      if (mode === 'opacityZero') {
        return 0;
      }
      var opacity = (scrollY > this.scrollHeight ? this.scrollHeight : scrollY) / this.scrollHeight;
      if (scrollY < 10) return opacity;
      return opacity < 0.5 ? 0.5 : opacity;
    },
    rootStyles: function rootStyles() {
      var display = this.isApp || this.$slots.right ? "block" : "none"; //app环境||right插槽存在内容
      return {
        display: display
      };
    },
    wrapStyles: function wrapStyles() {
      var position = this.isApp ? 'fixed' : 'relative';
      if (this.mode === 'default') {
        var _borderBottom = this.border ? "1px solid rgba(13, 46, 131, ".concat(this.alpha, ")") : undefined;
        return {
          position: position,
          backgroundColor: this.backgroundColor,
          borderBottom: _borderBottom
        };
      }
      var borderBottom = this.border && this.isApp ? "1px solid rgba(13, 46, 131, ".concat(this.alpha, ")") : 'none';
      var backgroundColor = "rgba(".concat(hexToRGB(this.backgroundColor), ",").concat(this.alpha, ")");
      return {
        position: position,
        borderBottom: borderBottom,
        backgroundColor: backgroundColor
      };
    },
    backStyles: function backStyles() {
      if (!this.isApp) {
        return {
          opacity: 0
        };
      }
      if (this.mode === 'default') {
        return {
          color: this.backgroundColor === '#0B2C82' || this.backgroundColor === '#0B2C82' ? '#ffffff' : '#006DFF'
        };
      }
      if (this.opacity === 1) {
        return {
          color: this.backgroundColor === '#0B2C82' ? '#ffffff' : '#006DFF'
        };
      }
      var color = this.alpha < 0.5 ? '#006DFF' : '#ffffff';
      var opacity = this.isApp ? 1 : 0; // app环境
      color = this.leftIconColor ? this.leftIconColor : color;
      return {
        opacity: opacity,
        color: color
      };
    },
    titleStyles: function titleStyles() {
      if (this.mode === 'default') {
        return {
          color: '#ffffff'
        };
      }
      if (this.opacity === 1) {
        return {
          color: '#ffffff'
        };
      }
      var color = this.alpha < 0.5 ? 'rgba(255,255,255,0)' : '#ffffff';
      var opacity = !this.isApp || this.alpha < 0.5 ? 0 : 1; // 非app环境||自定义背景色
      return {
        color: color,
        opacity: opacity
      };
    },
    rightStyles: function rightStyles() {
      var color = this.alpha < 0.5 ? '#006DFF' : '#ffffff';
      var display = this.$slots.right ? 'block' : 'none'; //如果right插槽存在内容
      return {
        display: display,
        color: color
      };
    }
  },
  methods: {
    handleBack: function handleBack() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.onBack) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this.onBack();
            case 3:
              _this.$router.back();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onPageScroll: function onPageScroll(e) {
      this.scrollY = e.target.scrollTop || document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0;
      // this.scrollY = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    window.addEventListener('scroll', this.onPageScroll);
  },
  beforeUnmount: function beforeUnmount() {
    window.removeEventListener('scroll', this.onPageScroll);
  },
  watch: {}
};